<template>
    <ContentOrLoading>
        <ModalComponent :name="'send-' + id" title="Enviar entradas" @close="close">
            <b-card no-body>
                <b-tabs card>
                    <b-tab title="Email" @click="whatsappForm = false, emailForm = true">
                        <FormInput class="col-12" :label="$t('formularios.nombre')" name="nombre" rules="required" v-model="nombre" />
                        <FormInput class="col-12" :label="$t('formularios.apellidos')" name="apellidos" rules="required" v-model="apellidos" />
                        <FormInput class="col-12" :label="$t('formularios.email')" name="email" rules="required" v-model="email" />
                    </b-tab>
                    <b-tab title="Whatsapp" @click="emailForm = false, whatsappForm = true">
                        <FormInput class="col-12" :label="$t('formularios.nombre')" name="nombre" rules="required" v-model="nombre" />
                        <FormInput class="col-12" :label="$t('formularios.telefono')" name="telefono" rules="required" v-model="telefono" />
                    </b-tab>
                </b-tabs>
                <div class="pl-3 pr-3">
                    <div class="form-group" v-if="errors">
                        <div class="alert alert-danger" role="alert">
                            <ul class="pl-2">
                                <template v-for="(error, index) in errors.errors">
                                    <li :key="index">
                                        {{ error[0] }}
                                    </li>
                                </template>                                                
                            </ul>
                        </div>
                    </div>
                    <div class="form-group mb-4" v-if="whatsapp_url && whatsappForm">
                        <div class="alert alert-success" role="alert">
                            <p>{{ $t('perfil.pedidos_url_generada') }}</p>
                            <Button v-if="whatsapp_url" type="button" :disabled="loading" @click="close" ref="enviarWhatsapp" :href="whatsapp_url" target="_blank">{{ $t('perfil.pedidos_envia_whatsapp') }}</Button>
                        </div>
                    </div>
                    <button id="enviar" class="button rounded mb-3" @click="enviar()" :disabled="loading">{{ $t('perfil.enviar') }}</button>
                </div>
            </b-card>
        </ModalComponent>
    </ContentOrLoading>
</template>

<script>
import ModalComponent from '@/components/backend/components/ModalComponent';

export default {
    props: {
        qr_codes: Array,
        order_id: Number,
        id: Number,
        entradas_id: {
            type: Array,
            default: () => null
        }
    },
    data() {
        return {
            errors: null,
            email: null,
            loading: false,
            emailForm: true,
            whatsappForm: false,
            nombre: null,
            apellidos: null,
            telefono: null,
            selected: null,
            options: [],
            whatsapp_url : ''
        }
    },
    methods: {
        close() {
            this.emailForm = false;
            this.whatsappForm = false;
            this.email = null;
            this.nombre = null;
            this.telefono = null;
            this.errors = null;
            this.selected = null;
            this.options = null;
            this.whatsapp_url = '';
            this.apellidos = null;
            this.$emit('actualizar');
            this.$emit('close', 'send-' + this.id);
        },

        enviarEmail(){
            const data = {
                user_order_id: this.order_id,
                email: this.email,
                nombre: this.nombre,
                apellidos: this.apellidos,
                qr_codes: this.qr_codes
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.ticket.send'), data).then(res => {
                this.$toast.success("Entradas enviadas correctamente");
                this.close();
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.errors = error.response.data; 
            });
        },
        enviarWhatsapp() {
            const data = {
                user_order_id: this.order_id,
                nombre: this.nombre,
                telefono: this.telefono,
                entradas_ids: this.entradas_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.ticket.send.whatsapp'), data).then(res => {
                this.$toast.success("Entradas enviadas correctamente");
                this.loading = false;
                this.whatsapp_url = res.data.url;
            }).catch(error => {
                this.loading = false;
                this.errors = error.response.data; 
            });

        },
        enviar() {
            this.loading = true;
            
            if(this.emailForm){
                this.enviarEmail();
            }else if (this.whatsappForm){
                this.enviarWhatsapp();
            }
                
        }
    },
    watch : {
        order_id: function(val) {
            this.emailForm = false;
            this.whatsappForm = false;
            this.email = null;
            this.nombre = null;
            this.telefono = null;
            this.errors = null;
            this.selected = null;
            this.options = null;
            this.whatsapp_url = '';
            this.apellidos = null;
        },
    },
    components: {
        ModalComponent
    }
}
</script>
